import { clearGlobalMenuCache } from '@/hooks/usePortalMenu';
import { performAutoLogout, performAutoLogin } from './auth-utils';
import { NSPortalAxiosInterceptor } from './micro-frontend-interceptor';

export type { ClientToken } from './types';

export { portalAxios } from './portal-axios';

const interceptorManager = new NSPortalAxiosInterceptor();

export const createAxiosForClient = (clientId: string) => {
  return interceptorManager.createClientInstance(clientId);
};

export const clearMicroFrontendTokens = () => {
  interceptorManager.clearAllTokens();
};

export const performManualLogout = async () => {
  interceptorManager.clearAllTokens();
  clearGlobalMenuCache();

  try {
    const { checkSessionValidity } = await import('./auth-utils');
    const sessionValid = await checkSessionValidity();

    if (sessionValid) {
      performAutoLogout();
    } else {
      performAutoLogin();
    }
  } catch {
    performAutoLogin();
  }
};
